<template>
    <div class="col-md-5 offset-md-1">
        <h3>Fallbeispiel - so funktioniert es:</h3>
        <ul class="timeline">
            <li class="timeline-item">
                <div class="timeline-date"><span>Anmeldung</span></div>
                <div class="timeline-content">
                    <div class="timeline-avatar"><img src="../../../assets/theme/img/avatar6.png" alt="" class="circle"></div>
                    <div class="timeline-header">
                        <span class="timeline-time"></span>
                        <span class="timeline-autor d-block">Kundin Eva Muster</span>
                        <p class="timeline-activity">Füllt online das <router-link :to="{ name: 'check' }">Buchungsformular</router-link> aus.</p>
                    </div>
                </div>
            </li>
            <li class="timeline-item">
                <div class="timeline-date"><span>Terminvereinbarung</span></div>
                <div class="timeline-content">
                    <div class="timeline-avatar"><img src="../../../assets/theme/img/avatar3.png" alt="" class="circle"></div>
                    <div class="timeline-header">
                        <span class="timeline-time">3 Tage später</span>
                        <span class="timeline-autor">Heidiland Digital-Coach</span>
                        <p class="timeline-activity">Innert 3 Arbeitstagen wird Eva Muster vom Heidiland Digital-Coach telefonisch kontaktiert, um einen Termin für das Assessment zu vereinbaren.</p>
                    </div>
                </div>
            </li>
            <li class="timeline-item">
                <div class="timeline-date"><span>Digital.Assessment</span></div>
                <div class="timeline-content">
                    <div class="timeline-avatar"><img src="../../../assets/theme/img/avatar3.png" alt="" class="circle"></div>
                    <div class="timeline-header">
                        <span class="timeline-time">120 Minuten</span>
                        <span class="timeline-autor">Heidiland Digital-Coach</span>
                        <p class="timeline-activity">Der Heidiland Digital-Coach führt vor Ort bei Eva Muster mit ihr das Assessment durch. Dies dauert rund 120 Minuten. Am Schluss des Assessment wird sogleich ein Termin für die Besprechung des Reports abgemacht. Dieser Termin findet in der Regel innerhalb der nächsten 14 Tagen statt.</p>
                    </div>
                </div>
            </li>
            <li class="timeline-item">
                <div class="timeline-date"><span>Digital.Solutions</span></div>
                <div class="timeline-content">
                    <div class="timeline-avatar"><img src="../../../assets/theme/img/avatar3.png" alt="" class="circle"></div>
                    <div class="timeline-header">
                        <span class="timeline-time">innert 14 Tagen</span>
                        <span class="timeline-autor">Heidiland Digital-Coach</span>
                        <p class="timeline-activity">Basierend aus den Ergebnissen des Checks und des Assessments stellt der Heidiland Digital-Coach passende Handlungsempfehlungen zusammen. Die Empfehlungen werden mit konkreten Umsetzungsvorschlägen ergänzt. Dies können Softwarelösungen sein, Promotions-Tipps, aber auch Video-Tutorials, mit denen sich Eva Muster selbst Wissen aneignen kann.</p>
                    </div>
                </div>
            </li>
            <li class="timeline-item">
                <div class="timeline-date"><span>Digital.Report</span></div>
                <div class="timeline-content">
                    <div class="timeline-avatar"><img src="../../../assets/theme/img/avatar3.png" alt="" class="circle"></div>
                    <div class="timeline-header">
                        <span class="timeline-time"></span>
                        <span class="timeline-autor">Heidiland Digital-Coach</span>
                        <p class="timeline-activity">Der Coach stellt die Informationen als Report zusammen, auf dem Eva Muster sieht wo Sie im Vergleich zu anderen Betrieben im Rahmen der Digitalisierung steht und wie sie sich verbessern kann. Der Report wird vor Ort bei Eva Muster besprochen.</p>
                    </div>
                </div>
            </li>
            <li class="timeline-item">
                <div class="timeline-date"><span>Digital.Coaching</span></div>
                <div class="timeline-content">
                    <div class="timeline-avatar"><img src="../../../assets/theme/img/avatar6.png" alt="" class="circle"></div>
                    <div class="timeline-header">
                        <span class="timeline-time"></span>
                        <span class="timeline-autor">Eva Muster</span>
                        <p class="timeline-activity">Eva Muster setzt die Handlungsempfehlungen Ihrer Wahl um und nutzt, wo sie nicht selbst in der Lage ist, die Hilfe von Spezialisten oder vom Heidiland Digital-Coach.</p>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {};
</script>
